import { TextStyles } from '@/constants';
import Image from 'next/image';
import { useState } from 'react';
import Typography from '../Typography';

interface LetterLogoProps {
  text: string;
}

const LetterLogo = ({ text }: LetterLogoProps) => {
  const firstLetter = text.slice(0, 1);
  return <Typography variant={TextStyles['Heading 1']}>{firstLetter}</Typography>;
};

interface PMCLogoProps {
  src?: string | null;
  alt?: string;
  placeholderText?: string;
  // biome-ignore lint/suspicious/noExplicitAny: extra props have dynamic shape
  [key: string]: any;
}

const PMCLogo = ({ src, alt, placeholderText, ...rest }: PMCLogoProps) => {
  const [isImageBroken, setIsImageBroken] = useState(false);

  if (src && !isImageBroken) {
    return <Image src={src} alt={alt || 'logo'} onError={() => setIsImageBroken(true)} {...rest} />;
  }

  return <LetterLogo text={placeholderText || ''} />;
};

export default PMCLogo;
